<template>
  <div class="sites">
    <div class="margin1">
      <button 
        class="flexccc navicon large newfont margin-tb radius border1"
        @click="$emit('Navigate','')"
      >
        <span class="material-icons big">home</span>
      </button>
    </div>
    <Grid1x1
      class="flex centercenter mb-4em">
      <div class="flex centercenter col2">
        <h1 class="newfont huge mt-0">Our Sites</h1>
      </div>
      <div>
        <p class="newfont large pad10p">A list of our sites that we develop, use to operate our services, and own as part of our portfolio</p>
      </div>
    </Grid1x1>
    <Grid1x1>
      <div class="sitesgrid">
        <div v-for="site in sites" :key="site.url" class="flexccc box">
          <a target="_blank" :href="site.url" class="linkfont">{{site.name}}</a>
        </div>
      </div>
    </Grid1x1>
    <Footer 
      class="border-top"
      copywrite="Composer Software 2022" 
    />
  </div>
</template>

<script>
// @ is an alias to /src
import Grid1x1 from '@/components/1x1grid.vue';
import Footer from '@/components/Footer';
export default {
  name: 'Sites',
  components: {
    Grid1x1,
    Footer,
  },
  data:function(){
    return {
      sites:[
        {
          name:"apasswordmanager.com",
          url:"https://apasswordmanager.com"
        },
        {
          name:"apims.co",
          url:"https://apims.co"
        },
        {
          name:"alphafiler.com",
          url:"https://alphafiler.com"
        },
        {
          name:"apidaydream.com",
          url:"https://apidaydream.com"
        },
        {
          name:"digitizem.com",
          url:"https://digitizem.com",
        },
        {
          name:"dimmle.com",
          url:"https://dimmle.com",
        },
        {
          name:"generationcoder.com",
          url:"https://generationcoder.com"
        },
        {
          name:"julsten.com",
          url:"https://julsten.com"
        },
        {
          name:"khatcat.com",
          url:"https://khatcat.com"
        },
        {
          name:"makeitmodels.com",
          url:"https://makeitmodels.com"
        },
        {
          name:"nfthypelist.com",
          url:"https://nfthypelist.com"
        },
        {
          name:"playbuttonmusic.com",
          url:"https://playbuttonmusic.com"
        },
        {
          name:"pollerskate.com",
          url:"https://pollerskate.com"
        },
        {
          name:"prototypeschemas.com",
          url:"https://prototypeschemas.com"
        },
        {
          name:"restsoftware.com",
          url:"https://restsoftware.com"
        },
        {
          name:"shpesh.com",
          url:"https://shpesh.com"
        },
        {
          name:"software9000.com",
          url:"https://software9000.com"
        },
        {
          name:"specializesoftware.com",
          url:"https://specializesoftware.com"
        },
        {
          name:"tenxware.com",
          url:"https://tenxware.com"
        }
      ],
      modalActive:false,
      messageSuccess:false,
      messageError:false,
      modalStyles:{
        zIndex:-1,
        opacity:0
      },
      modalContentStyles:{
        position:"absolute",
        left:"50%",
        transform:"translateX(-50%)",
        zIndex:11
      },
      contactGridStyles:{
        width:"100vw",
        minHeight:"75px",
        border:"none"
      },
      contactFormContainer:{
        position:"absolute",
        left:"50%",
        transform:"translateX(-50%)",
        top:"15%",
        zIndex:12
      },
      SuccessMessageInnerStyles:{
        fontSize:"2em",
        color:"green"
      },
      SuccessMessageStyles:{
        zIndex:13,
        position:"absolute",
        left:"50%",
        top:"30%",
        transform:"translateX(-50%)",
        backgroundColor:"#fff"
      },
      ErrorMessageInnerStyles:{
        color:"red",
        fontSize:"2em"
      },
      ErrorMessageStyles:{
        zIndex:13,
        position:"absolute",
        left:"50%",
        top:"30%",
        transform:"translateX(-50%)",
        backgroundColor:"#fff"
      },
      catpcha1:null
    } 
  },
  methods:{
    preventTab(objEvent){
      if(objEvent.keyCode == 9) {  //tab pressed
        objEvent.preventDefault(); // stops its action
      }
    },
    Redirect(path){
      this.$router.push({path:`/${path}`});
    },
    activateModal(){
      //document.querySelector('body').style.overflow = "hidden"
      this.modalActive = true;
      this.showContactForm = true;
      this.modalStyles = {
        position:"fixed",
        zIndex:10,
        opacity:0.8
      }
      this.renderCaptcha()
    },
    deactivateModal(){
      document.querySelector('body').style.overflow = ""
      this.modalActive = false;
      this.modalStyles = {
        position:"fixed",
        zIndex:-1,
        opacity:0
      }
      this.showContactForm = false;
    },
    handleError(){
      this.messageError = true;
      this.showContactForm = false;
      setTimeout(() => {
        this.deactivateModal()
        this.messageError = false;
      },4000);
    }
  },
  computed:{
  },
  created(){

  }
}
</script>

<style scoped>
.home {
  display:grid;
}
.margin1 {
  margin:10px 10px;
}
.img-ctn {
  width:100%;
  overflow:hidden;
}
img {
  object-fit:cover;  
  width:100%;
}
.fade-leave-active {
  transition: opacity .333s;
}
.newfont {
  font-family:'Bodoni Elegant Regular';
  font-weight:100;
}
.border-btm {
  border-bottom: 1px solid #767676;
}
.border-top {
  border-top: 2px solid #767676;
}
.flexccc {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.navicon {
  cursor:pointer;
  transition: all 1s ease;
}

.navicon:hover {
  cursor:pointer;
  color:white;
  background-color:black;
}
.large {
  font-size:2em;
}
.big {
  font-size:3em;
}
.huge {
  font-size:6em;
}
.border1 {
  border: 8px solid black;
}
.radius {
  border-radius:15px;
}
.navbtn {
  cursor:pointer;
  transition: all 0.7s ease-in-out;
  color:black;
  background-color:white;
  border-bottom:none;
  padding:.51em 2.5em;
  width:100%;
  font-size:5em;
}
.mt-0 {
  margin-top:0;
}
.mb-4em {
  margin-bottom:4em;
}
.margin-tb {
  margin: 10px 0px;
}
.navbtn:hover {
  cursor:pointer;
  transition: all 0.7s ease-in-out;
  color:white;
  background-color:black;
}
.pad10p {
  padding:0 10%;
}
.linkfont {
  font-size:1.3em;
}
.sitesgrid {
  display:grid;
  grid-template-columns:repeat(3, 1fr);
  padding:0 10%;
  grid-gap:50px;
  justify-items:stretch;
  margin-bottom:10%;
}
.flex {
  display:flex;
  border:none;
  flex-direction: column;
}
.centercenter {
  align-items:center;
  justify-content:center;
}

.box {
  min-height:200px;
  border:3px solid black;
  border-radius:15px;
}

@media only screen and (max-width: 900px) {
  .navbtn {
    padding:.31em 1em;
    font-size:3em;
  }
  .sitesgrid {
    display:grid;
    grid-template-columns:repeat(2, 1fr);
    padding:0;
    grid-gap:50px;
    justify-items:stretch;
    margin-bottom:10%;
  }
}
@media only screen and (max-width: 600px) {
  .navbtn {
    padding:0;
    font-size:2em;
  }
  .linkfont {
    font-size:1em;
  }
  .sitesgrid {
    display:grid;
    grid-template-columns:repeat(2, 1fr);
    padding:0;
    justify-items:stretch;
    margin-bottom:10%;
    grid-gap:5px;
  }
}
</style>
